import React, { useEffect, useState } from "react";
import Footer from "../Components/Footer";
import IndiaBoatsTopBar from "../Components/IndiaBoatsTopBar";
import PremiumNavbar from "../Components/PremiumNavbar";
import AuthPrompt from "../Components/AuthPrompt";
import { useNavigate } from "react-router-dom";

export default function Login() {
  const API_URL = "/api";
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [showSignupPrompt, setShowSignupPrompt] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    const existingUser = JSON.parse(localStorage.getItem("user") || "null");
    if (existingUser?._id || existingUser?.id || existingUser?.email) {
      navigate("/");
    }
  }, [navigate]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
    setErrorMessage("");
  };

  const validate = () => {
    let newErrors = {};

    if (!form.email) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(form.email)) {
      newErrors.email = "Invalid email";
    }

    if (!form.password) {
      newErrors.password = "Password is required";
    }

    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validate();

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setLoading(true);
    setErrorMessage("");

    try {
      const response = await fetch(`${API_URL}/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: form.email,
          password: form.password,
        }),
      });

      const data = await response.json();

      if (response.status === 404 || data.code === "NOT_REGISTERED") {
        setShowSignupPrompt(true);
        return;
      }

      if (response.ok && data.data) {
        localStorage.setItem("user", JSON.stringify(data.data));
        navigate("/");
        return;
      }

      setErrorMessage(data.message || "Invalid credentials");
    } catch (error) {
      console.error(error);
      setErrorMessage("Something went wrong!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <IndiaBoatsTopBar />
      <PremiumNavbar />
      <section className="user-login-section-container">
        <div className="login-card">
          <h2 className="login-title">Welcome Back</h2>
          <p className="login-subtitle">
            Sign in to manage your bookings and preferences.
          </p>
          <form className="login-form" onSubmit={handleSubmit}>
            <div className="input-group">
              <label htmlFor="login-email" className="input-label">
                Email Address
              </label>
              <input
                type="email"
                name="email"
                className="login-input"
                placeholder="youremail@example.com"
                value={form.email}
                onChange={handleChange}
              />
              {errors.email && <p className="error">{errors.email}</p>}
            </div>
            <div className="input-group">
              <label htmlFor="login-password" className="input-label">
                Password
              </label>
              <input
                type="password"
                name="password"
                className="login-input"
                placeholder="••••••••"
                value={form.password}
                onChange={handleChange}
              />
              {errors.password && <p className="error">{errors.password}</p>}
            </div>
            {errorMessage ? <p className="error">{errorMessage}</p> : null}
            <div className="login-options-row">
              <div className="remember-me">
                <input
                  type="checkbox"
                  id="remember-me-checkbox"
                  className="login-checkbox"
                />
                <br></br>
                <label htmlFor="remember-me-checkbox" className="checkbox-label">
                  Remember my details
                </label>
              </div>
            </div>
            <button type="submit" className="login-submit-btn" disabled={loading}>
              {loading ? "Logging in..." : "Log In"}
            </button>
          </form>
          <div className="login-footer">
            <p>
              Don't have an account?{" "}
              <a href="/signup" className="signup-link">
                Sign Up
              </a>
            </p>
          </div>
        </div>
      </section>

      <AuthPrompt
        open={showSignupPrompt}
        title="Account not found"
        message="Please sign up first to create your IndiaBoats account, then come back to log in."
        primaryLabel="Sign Up"
        primaryPath="/signup"
        onClose={() => setShowSignupPrompt(false)}
      />

      <Footer />
    </>
  );
}
